import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDownsize2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="downsize-2, exit-full-screen, scale-down"><path d="M3.75 10.25H10.25V3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M20.25 10.25H13.75V3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M13.75 20.25V13.75H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 13.75H10.25V20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconDownsize2;
